export const transformDate = (dateFromServer: string) => {
  const date = new Date(dateFromServer).toLocaleString("ru-RU", {
    dateStyle: "short",
    timeStyle: "short",
  })

  return date
}
